import React from 'react';

import BareLayout from './BareLayout';
import WithTracking from '../WithTracking';

const BareLayoutWithTracking = props => (
  <WithTracking {...props}>
    <BareLayout {...props} />
  </WithTracking>
);

export default BareLayoutWithTracking;
